import { httpClient } from './http';

export type ClientDocumentsQuery = {
  page?: number;
  pageSize?: number;
  entityTypes?: Array<'CONTRACT' | 'APPOINTMENT' | 'INVOICE'>;
};

export type ClientDocumentItem = {
  id: string;
  source: 'generated' | 'uploaded';
  name: string;
  documentType?: 'IDENTITY_CARD' | 'MEDICAL_DOCUMENT' | 'OTHER' | null;
  category: string;
  sizeBytes: number;
  uploadedAt: string;
  status: 'pending' | 'approved' | 'rejected';
  description?: string;
  url: string;
  deleteAllowed: boolean;
  isSigned?: boolean;
  requiredSigners?: string[];
  signedRoles?: string[];
};

export class ClientDocumentsApi {
  async list(query?: ClientDocumentsQuery) {
    const qs = new URLSearchParams();
    if (query?.page !== undefined) qs.set('page', String(query.page));
    if (query?.pageSize !== undefined) qs.set('pageSize', String(query.pageSize));
    if (query?.entityTypes?.length) qs.set('entityTypes', query.entityTypes.join(','));
    const suffix = qs.toString() ? `?${qs.toString()}` : '';
    return await httpClient.get<any>(`/api/client-documents${suffix}`);
  }

  async upload(params: {
    file: File;
    documentType: 'IDENTITY_CARD' | 'MEDICAL_DOCUMENT' | 'OTHER';
    name: string;
    descriptionHtml?: string;
    metadata?: Record<string, any>;
  }) {
    const token = localStorage.getItem('client_token');
    const baseUrl = import.meta.env.VITE_API_URL || '';
    const form = new FormData();
    form.append('file', params.file);
    form.append('documentType', params.documentType);
    form.append('name', params.name);
    if (params.descriptionHtml) form.append('descriptionHtml', params.descriptionHtml);
    if (params.metadata) form.append('metadata', JSON.stringify(params.metadata));

    const res = await fetch(`${baseUrl}/api/client-documents/uploads`, {
      method: 'POST',
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
      body: form,
    });

    const contentType = res.headers.get('content-type') || '';
    const data = contentType.includes('application/json') ? await res.json() : null;
    if (!res.ok) throw new Error(data?.message || 'Failed to upload');
    return data;
  }

  async deleteUpload(uploadId: string) {
    return await httpClient.request<any>(`/api/client-documents/uploads/${encodeURIComponent(uploadId)}`, { method: 'DELETE' });
  }
}

export const clientDocumentsApi = new ClientDocumentsApi();


